import { supabaseClient } from 'supabase'

export type QueryAdvertiserByIDParams = {
  id: string
}

export const queryAdvertiserByID = async ({ id }: QueryAdvertiserByIDParams) => {
  const { data, error } = await supabaseClient
    .from('advertisers')
    .select('*')
    .eq('id', id)
    .single()

  if (error) {
    throw error
  }

  return data
}